import { createApp } from 'vue';
import ReviewPrompt from './ReviewPrompt.vue';

// Mounts only when the server rendered the placeholder, which it does exactly once per queued
// prompt (see ReviewPromptHelper#review_prompt_due?). On every other page load this is a no-op,
// so the global entrypoint can import it unconditionally.
const el = document.querySelector<HTMLElement>('#review-prompt');
if (el) {
  createApp(ReviewPrompt, {
    contextLabel: el.dataset.contextLabel || 'A quick question',
    reviewUrl: el.dataset.reviewUrl || '',
    dismissUrl: el.dataset.dismissUrl || '',
    feedbackUrl: el.dataset.feedbackUrl || ''
  }).mount(el);
}
